import React from 'react';
import '../template-file-css/document-file-template.css';



export const HFI_Form16 = ({
    itemsRef,
    showErrorFor,
    
}) => {

    return (
        <form id='HFI_Form16' className='file-pdf-document'>
            <div className='file-template'>
            <p className='w-750'><center><h3>HERITAGE FOUNDATION INC.</h3></center>
                    <br />
                    <center><h4>AUTHORIZATION FOR RELEASE OF INFORMATION</h4></center>
                    <b>I hereby request and authorize:</b></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Name of the Person or Agency Requesting Information </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtNameOfThePersonAgency' name='txtNameOfThePersonAgency' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Address</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtAddress' name='txtAddress' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><b>To obtain from:</b></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Name of the Person or Agency Requesting Information </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtNameOfThePersonAgency_1' name='txtNameOfThePersonAgency_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Address</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtAddress_1' name='txtAddress_1' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>The following type(s) of information from my records (and any specific portion hereof)</span>
                    <textarea id='txtTheFollowingTypeInformation' name='txtTheFollowingTypeInformation' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>For the purpose of: </span>
                    <textarea id='txtForThePurpose' name='txtForThePurpose' className='add-only'></textarea></p>

                <p className='w-750'>All information I hereby authorize to be obtained from this agency will be held strictly confidential and cannot be released by the recipient without my written consent.
                    I understand that this authorization will remain in effect for: <br />
                    <input type='checkbox' id='cbAllInformationIHerebyAuthorize_1' name='cbAllInformationIHerebyAuthorize_1' className='add-only' value='1' />ninety (90) days unless I specify an earlier expiration date here:
                    <input type='text' id='txtLastName' name='txtLastName' className='add-only w-200 custom-add-only' /><br />

                    <input type='checkbox' id='cbAllInformationIHerebyAuthorize_2' name='cbAllInformationIHerebyAuthorize_2' className='add-only' value='2' /> one (1) year. <br />
                    <input type='checkbox' id='cbAllInformationIHerebyAuthorize_3' name='cbAllInformationIHerebyAuthorize_3' className='add-only' value='3' /> the period necessary to complete all transactions on accounts related to services provided to me</p>

                <p className='w-750'><center>I understand that unless otherwise limited by state or federal regulation, and except to the extent that action has been taken which was based on my consent,
                    I may withdraw this consent at any time.</center></p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature of Enrolled /Former Enrolled</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature of Parent or Authorized Representative</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature of Witness(Relationship)</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>

                <p className='w-750'><center><h4>USE THIS SPACE ONLY IF THE CLIENT WITHDRAWS CONSENT</h4></center></p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Date consent is revoked by Enrolled/Former Enrolled</td>
                        <td className='small w-375'>Signature of Enrolled/Former Enrolled</td>
                    </tr>
                    
                   
                </table>

            


            </div>
        </form>

    )
}  
